import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EvacuationMapModal = ({ isOpen, onClose, zone }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-card rounded-lg shadow-conservation-lg max-w-4xl w-full max-h-[90vh] overflow-hidden">
        <div className="p-6 border-b border-border flex items-center justify-between">
          <div>
            <h2 className="text-card-foreground font-semibold text-2xl">Evacuation Routes</h2>
            <p className="text-muted-foreground">{zone}</p>
          </div>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-card-foreground animation-organic"
            aria-label="Close modal"
          >
            <Icon name="X" size={24} />
          </button>
        </div>
        
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-180px)]">
          <div className="bg-muted/10 rounded-lg overflow-hidden mb-6" style={{ height: '400px' }}>
            <iframe
              width="100%"
              height="100%"
              loading="lazy"
              title="Evacuation Route Map"
              referrerPolicy="no-referrer-when-downgrade"
              src="https://www.google.com/maps?q=9.7489,118.7384&z=14&output=embed"
            />
          </div>
          
          <div className="space-y-4">
            <div className="bg-success/10 border border-success/20 rounded-lg p-4">
              <div className="flex items-center gap-2 text-success mb-2">
                <Icon name="MapPin" size={18} />
                <span className="font-semibold">Primary Assembly Point</span>
              </div>
              <p className="text-card-foreground">Visitor Center Main Parking Area</p>
              <p className="text-muted-foreground text-sm">Coordinates: 9.7489°N, 118.7384°E</p>
            </div>
            
            <div className="bg-info/10 border border-info/20 rounded-lg p-4">
              <div className="flex items-center gap-2 text-info mb-2">
                <Icon name="MapPin" size={18} />
                <span className="font-semibold">Secondary Assembly Point</span>
              </div>
              <p className="text-card-foreground">Sabang Beach Emergency Station</p>
              <p className="text-muted-foreground text-sm">Coordinates: 9.7512°N, 118.7401°E</p>
            </div>
            
            <div className="bg-warning/10 border border-warning/20 rounded-lg p-4">
              <h4 className="text-warning font-semibold mb-2 flex items-center gap-2">
                <Icon name="AlertTriangle" size={18} />
                Important Instructions
              </h4>
              <ul className="space-y-2 text-card-foreground">
                <li className="flex gap-2">
                  <Icon name="ChevronRight" size={16} className="text-warning mt-1 flex-shrink-0" />
                  <span>Follow marked evacuation routes indicated by green signage</span>
                </li>
                <li className="flex gap-2">
                  <Icon name="ChevronRight" size={16} className="text-warning mt-1 flex-shrink-0" />
                  <span>Stay with your group and follow ranger instructions</span>
                </li>
                <li className="flex gap-2">
                  <Icon name="ChevronRight" size={16} className="text-warning mt-1 flex-shrink-0" />
                  <span>Do not return to restricted areas until all-clear is given</span>
                </li>
                <li className="flex gap-2">
                  <Icon name="ChevronRight" size={16} className="text-warning mt-1 flex-shrink-0" />
                  <span>Report to assembly point for headcount verification</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="p-6 border-t border-border flex justify-end gap-3">
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
          <Button variant="default" iconName="Download">
            Download Map
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EvacuationMapModal;